import { ThemeProvider, createTheme } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import React from 'react';

interface IDateSelectProps {
  title?: string;
  subTitle?: string;
  selectedDate: string;
  setSelectedDate: (_date: string) => void;
  mode?: 'date' | 'monthYear';
  isDisabled?: boolean;
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#6571FF',
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root': {
            alignItems: 'center',
          },
          '& .MuiInputBase-input': {
            padding: '0.15rem 0.5rem',
            width: '8rem',
            fontSize: '1rem',
            fontWeight: '400',
            fontFamily: '"Inter", "Helvetica Neue", sans-serif',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#9c9c9c',
            borderWidth: '1px',
            borderRadius: '0.35rem',
          },
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: { root: { width: '20px' } },
    },
  },
});

export const DateSelect: React.FC<IDateSelectProps> = ({
  title,
  setSelectedDate,
  selectedDate,
  subTitle,
  mode = 'date',
  isDisabled = false,
}) => {
  const handleDateChange = (date: moment.Moment | null) => {
    setSelectedDate(date ? date.toISOString() : '');
  };

  const handleMonthYearChange = (date: moment.Moment | null) => {
    setSelectedDate(date ? date.format('MM/YYYY') : '');
  };

  return (
    <div className="flex flex-col">
      {title && <p className="text-lg text-black mb-1">{title}</p>}
      {subTitle && <p className="text-sm text-gray-600 mb-1">{subTitle}</p>}

      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en">
          {mode === 'date' ? (
            <DatePicker
              disabled={isDisabled}
              format="DD/MM/YYYY"
              value={selectedDate ? moment(selectedDate, 'DD/MM/YYYY') : null}
              onChange={handleDateChange}
              slotProps={{ openPickerButton: { color: 'primary' } }}
            />
          ) : (
            <DatePicker
              disabled={isDisabled}
              value={selectedDate ? moment(selectedDate, 'MM/YYYY') : null}
              onChange={handleMonthYearChange}
              minDate={moment().startOf('year')}
              maxDate={moment().endOf('year').add(5, 'years')}
              views={['year', 'month']}
              slotProps={{
                openPickerButton: {
                  color: 'primary',
                },
              }}
            />
          )}
        </LocalizationProvider>
      </ThemeProvider>
    </div>
  );
};
